// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.presentation {
    display: flex;
    flex-direction: row;
    align-items: start;
    gap: 90px;
}

.sod-round-text {
    width: 20%;
    display: block;
    margin-left: auto;
    margin-right: auto;
    object-fit: contain;
}

@media (max-width: 100%) {
    .presentation {
        flex-direction: column;
        gap: 40px;
    }

    .presentation .sod-round-text {
        width: 50%;
        margin: auto;
    }
}

.presentation .block {
    display: flex;
    flex-direction: column;
    gap: 40px;
    font-size: 17px;
    font-weight: 500;
    text-align: justify;
    line-height: 30px;
    padding: 50px;
}`, "",{"version":3,"sources":["webpack://./src/style/presentation.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,mBAAmB;IACnB,kBAAkB;IAClB,SAAS;AACb;;AAEA;IACI,UAAU;IACV,cAAc;IACd,iBAAiB;IACjB,kBAAkB;IAClB,mBAAmB;AACvB;;AAEA;IACI;QACI,sBAAsB;QACtB,SAAS;IACb;;IAEA;QACI,UAAU;QACV,YAAY;IAChB;AACJ;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,SAAS;IACT,eAAe;IACf,gBAAgB;IAChB,mBAAmB;IACnB,iBAAiB;IACjB,aAAa;AACjB","sourcesContent":[".presentation {\n    display: flex;\n    flex-direction: row;\n    align-items: start;\n    gap: 90px;\n}\n\n.sod-round-text {\n    width: 20%;\n    display: block;\n    margin-left: auto;\n    margin-right: auto;\n    object-fit: contain;\n}\n\n@media (max-width: 100%) {\n    .presentation {\n        flex-direction: column;\n        gap: 40px;\n    }\n\n    .presentation .sod-round-text {\n        width: 50%;\n        margin: auto;\n    }\n}\n\n.presentation .block {\n    display: flex;\n    flex-direction: column;\n    gap: 40px;\n    font-size: 17px;\n    font-weight: 500;\n    text-align: justify;\n    line-height: 30px;\n    padding: 50px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
